export default __webpack_public_path__ + "images/4 СМЕТА_.jpg";